export default function BaseUrl() { return "https://api.thesocialstudio417.com"; };
